module.exports = __webpack_public_path__ + "media/images/p-about/about/investor-bc4218465fd4b55ef47849b9c3e7ea2e.svg";